import styled from "styled-components";
import { PRIMARY, SECONDARY, DARKER } from "../../const/colors";
import { SlideIn, SlideOut } from "../animations/LoginAnimations";

export const Container = styled.div.attrs((props) => ({
  className: props.className,
}))`
  position: absolute;
  top: 3.7rem;
  right: -37%;
  background: white;
  border: 1px solid ${SECONDARY};
  width: max-content;
  z-index: 1000;
  opacity: 0;
  visibility: none;
  pointer-events: none;

  &::before {
    content: "";
    position: absolute;
    top: -25px;
    right: 2.2rem;
    border-top: 10px solid transparent;
    border-bottom: 15px solid ${SECONDARY};
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }

  &::after {
    content: "";
    position: absolute;
    top: -23px;
    right: 2.2rem;
    border-top: 10px solid transparent;
    border-bottom: 15px solid white;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }

  &.active {
    animation: ${SlideIn} 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  &.close {
    animation: ${SlideOut} 0.7s both;
  }

  @media screen and (max-width: 1500px) {
    right: 10%;
    top: 3rem;

    &::before,
    &::after {
      right: 0.5rem;
    }
  }
  @media screen and (max-width: 1080px) {
    display: none;
  }
`;

export const Menu = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  width: 100%;
  &.d-none{
  display:none;
  }
`;

export const Item = styled.div.attrs((props) => ({
  className: props.className,
}))`
  border-bottom: 1px solid ${DARKER};
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  position:relative;
  overflow: hidden;
  width:100%;
  svg {
    color: ${SECONDARY};
    margin-right: 0.5rem;
    width: 20px;
    height: 20px;
    font-size: 20px;
  }
  span {
    color: ${SECONDARY};
  }

  &.danger {
    background-color: red;
    svg {
      color: #fff;
    }
    border-bottom: none;
  }

  span.badget {
    border-radius: 1rem;
    padding: 0px 0.25rem 0px 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0.8rem;
    right: 0.5rem;
    font-weight: normal;
    font-size: 0.6rem;

    svg {
      font-size: 16px;
      margin-right: 0;
      width: 16px;
      height: 16px;
      margin-bottom: 2px;
    }
  }

  span.verificado {
    background-color: #28a745;
    color: #fff;
    svg {
      color: #fff;
    }
  }
  span.sinverificar {
    background-color: ${SECONDARY};
    color: ${PRIMARY};
    svg {
      color: ${PRIMARY};
    }
  }
  &:hover {
    background-color: ${SECONDARY};
    span {
      color: white;
    }
      svg {
      color: ${PRIMARY};
    }
  }

  span.new {
    position: absolute;
    top: 10px;
    left: 5px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: red;
  }
  a,
  button {
    outline: none;
    width: 100%;
    line-height: 2;
    padding: 0.7rem 1rem;
    padding-right: 4rem;
    border: none;
    font-weight: bold;
    font-size: 0.8rem;
    text-align: start;
    background-color: transparent;
    color: ${PRIMARY};
    display: flex;
    align-items: center;
    position: relative;

    cursor: pointer;
  }
  &.newribbon:after{
    content: "new";
    background: #28a745;
    color:white;
    position: absolute;
    top: 10px;
    right: -15px;
    padding: 0 1.2rem;
    font-weight: bold;
    font-size: 12px;
    transform: rotate(45deg);
    -webkit-animation-duration: 1.2s;
    animation-duration: 1.2s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-name: pulsegif;
    animation-name: pulsegif;
  }
  @-webkit-keyframes pulsegif {
    from {
      -webkit-transform: scale3d(1, 1, 1) rotate(45deg);
      transform: scale3d(1, 1, 1) rotate(45deg);
    }
  
    50% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(45deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate(45deg);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1) rotate(45deg);
      transform: scale3d(1, 1, 1) rotate(45deg);
    }
  }
  
  @keyframes pulsegif {
    from {
      -webkit-transform: scale3d(1, 1, 1) rotate(45deg);
      transform: scale3d(1, 1, 1) rotate(45deg);
    }
  
    50% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(45deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate(45deg);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1) rotate(45deg);
      transform: scale3d(1, 1, 1) rotate(45deg);
    }
  }
  @media screen and (max-width: 1500px) {
    a {
      padding-right: 2rem;
    }
    a,
    button {
      font-size: 0.75rem;
    }
    > svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

export const Megamenu = styled.div`
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    min-width: 460px;
    @media screen and (max-width: 640px) {
      min-width: 100%;
      //padding-top: 0.5rem;
    }
`;
export const Row = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  &.border-y{
    border-bottom:1px solid ${SECONDARY}
  }
`;
export const Col = styled.div`
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding: 0.75rem 0.65rem;
  overflow: hidden;
  .titleSaldo{
    font-size: 1.2rem;
  }
  > .d-flex-col{
      display: flex;
      justify-content: start;
      align-items: center;
      input{
        display:none;
      }
      > .myimage{
        width: 110px;
        height: 110px;
        border-radius: 50%;
        box-shadow: rgb(128, 103, 4) 0px 0px 2px;
        background-color: rgb(12, 14, 30);
        position: relative;
        margin-right:1rem;
        >  img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 100%;
          cursor:pointer;
        }
       }
        
      }
  .d-flex-icons{
    display: flex;
    justify-content: start;
    align-items: center;
    svg{
      margin-right:15px;
      min-width: 22px;
      min-height: 22px;
      path{
       fill:${SECONDARY};
      }
    }
  }
  &.pb-0{
    padding-bottom:0;
  }
  &.border{
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    padding-right: 0;
    padding-left: 0;
    cursor:pointer;
    transition: 0.5s all;
    > a {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-weight: bold;
      font-size: 0.8rem;
      text-align: center;
      height: 50px;
      > svg{
        color: ${SECONDARY};
        width: 22px;
        height: 22px;
        font-size: 22px;
        margin-bottom: 0.5rem;
        path{
          fill: ${SECONDARY};
        }
        circle{
          stroke: ${SECONDARY};
        } 
      }
    }
    &:hover{
      border-right: 1px solid ${SECONDARY};
      border-bottom: 1px solid ${SECONDARY};
      background:${SECONDARY};
      transition: 0.5s all;
      transform: scale(1.05);
      z-index:10;
      span {
        color: white;
      }
      a > svg{
        color: ${PRIMARY};
        path{
          fill: ${PRIMARY};
          stroke: ${PRIMARY};
        }
        circle{
          stroke: ${PRIMARY};
        } 
      }
    }
  }
  > button {
    outline: none;
    width: 100%;
    line-height: 2;
    border: none;
    font-weight: bold;
    font-size: 0.8rem;
    text-align: start;
    background-color: transparent;
    color: ${PRIMARY};
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
  }
  span {
    color: ${SECONDARY};
    &.saldouser{
      display: block;
      font-weight: bold;
      font-size: 1.2rem;
      padding: 0.55rem 0rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 6vw;
    }
    &.saldototal{
      font-size: 1.3rem;
    }
  }
  @media screen and (max-width: 640px) {
    span {
        &.saldouser{
          font-size: 1rem;
          width: 22vw;
        }
        &.saldototal{
          font-size: 1.3rem;
          width: 55vw;
        }
      }
    > .d-flex-col{
      > .myimage{
        width: 130px;
        height: 130px;
        box-shadow: rgb(0 0 0) 0px 0px 5px;
      }
    }
    .titleSaldo{
      font-size: 1.3rem;
    }
  }
  &.danger {
    background-color: red;
    svg {
      color: #fff;
      margin-right:10px;
    }
    span{
      color:white;
    }
    border-bottom: none;
  }

  span.badget {
    border-radius: 1rem;
    padding: 0px 0.25rem 0px 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    font-weight: bold;
    font-size: 0.6rem;

    svg {
      font-size: 16px;
      margin-right: 0;
      width: 16px;
      height: 16px;
      margin-bottom: 2px;
    }
  }

  span.verificado {
    background-color: #28a745;
    color: #fff;
    svg {
      color: #fff;
    }
  }
  span.sinverificar {
    background-color: ${SECONDARY};
    color: ${PRIMARY};
    svg {
      color: ${PRIMARY};
    }
  }
  span.new {
    position: absolute;
    top: 10px;
    left: 5px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: red;
  }
  p{
    color:${SECONDARY};
    font-weight: bold;
    font-size: 0.8rem;
    text-align: start;
  }
  .animated {
    -webkit-animation-duration: 4s;
    animation-duration: 4s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    &.infinite {
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }
  }
  .tada {
      -webkit-animation-name: tada;
      animation-name: tada;
  }
  .swing {
    -webkit-transform-origin: top center;
    transform-origin: top center;
    -webkit-animation-name: swing;
    animation-name: swing;
  }
  @-webkit-keyframes swing {
    20% {
      -webkit-transform: rotate3d(0, 0, 1, 15deg);
      transform: rotate3d(0, 0, 1, 15deg);
    }

    40% {
      -webkit-transform: rotate3d(0, 0, 1, -10deg);
      transform: rotate3d(0, 0, 1, -10deg);
    }

    60% {
      -webkit-transform: rotate3d(0, 0, 1, 5deg);
      transform: rotate3d(0, 0, 1, 5deg);
    }

    80% {
      -webkit-transform: rotate3d(0, 0, 1, -5deg);
      transform: rotate3d(0, 0, 1, -5deg);
    }

    to {
      -webkit-transform: rotate3d(0, 0, 1, 0deg);
      transform: rotate3d(0, 0, 1, 0deg);
    }
  }

  @keyframes swing {
    20% {
      -webkit-transform: rotate3d(0, 0, 1, 15deg);
      transform: rotate3d(0, 0, 1, 15deg);
    }

    40% {
      -webkit-transform: rotate3d(0, 0, 1, -10deg);
      transform: rotate3d(0, 0, 1, -10deg);
    }

    60% {
      -webkit-transform: rotate3d(0, 0, 1, 5deg);
      transform: rotate3d(0, 0, 1, 5deg);
    }

    80% {
      -webkit-transform: rotate3d(0, 0, 1, -5deg);
      transform: rotate3d(0, 0, 1, -5deg);
    }

    to {
      -webkit-transform: rotate3d(0, 0, 1, 0deg);
      transform: rotate3d(0, 0, 1, 0deg);
    }
  }

  @-webkit-keyframes tada {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    10%, 20% {
      -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
      transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
    }

    30%, 50%, 70%, 90% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    }

    40%, 60%, 80% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    }

    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  @keyframes tada {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    10% {
      -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
      transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
    }

    15%, 25%, 35%, 45% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    }

    20%, 30%, 40% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    }
    50% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
`
export const Buttonsave = styled.button`
  left: 0 !important;
  right: initial !important;
  position: absolute;
  bottom: 0rem;
  left: 0px;
  background-color: ${PRIMARY};
  border: none;
  border-radius: 50%;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
  cursor: pointer;
  > svg {
    color: ${SECONDARY};
  }
  &:hover {
    background-color: #fff;
  }
`